const numberFormatter = new Intl.NumberFormat('sv-SE')

export function formatNumber(value: number): string {
  return numberFormatter.format(value)
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString('sv-SE')
}

const currencyFormatter = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' })

export function formatCurrency(value: number): string {
  return currencyFormatter.format(value)
}

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short' })
}

const SWEDISH_TIME_ZONE = 'Europe/Stockholm'

export function formatSwedishDateTime(value: string): string {
  return new Date(value).toLocaleString('sv-SE', { dateStyle: 'short', timeStyle: 'short', timeZone: SWEDISH_TIME_ZONE })
}

export function formatSwedishDay(date: Date): string {
  return date.toLocaleDateString('sv-SE', { timeZone: SWEDISH_TIME_ZONE })
}
